














































import { Component, Vue, Watch } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import billingApi from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter, Mutation } from "vuex-class";

import { NSLog } from "@/helpers/log";
import { edit as EditBundle } from "@/dialogs/bundle";
import { Package } from "@/models/package";
import { Bundle } from "@/models/bundle";
import ProductIcon from "@/components/ProductIcon.vue";
const log = NSLog("view/ManagePackages");

@Component({
  components: {
    loader,
    EditBundle,
    ProductIcon
  }
})
export default class ManagePackages extends Vue {
  private loading = false;

  gotoReport(name: string) {
    this.$router.push(`/manage/reporting/${name}`);
  }
}
